import React, { useState, useEffect } from "react";

import { __ } from "services/Translator";
import api from "services/api";
import { Modal, Accordion } from "react-bootstrap";
import { isMobile } from "services/isMobile";
import { Link } from "react-router-dom";
import axios from "axios";

export default function FiatDeposit(props) {
  // const depositAmounts = [10, 20, 50, 100, 200, 500, 1000, 5000];

  const depositAmounts = [10, 50, 150, 20, 75, 250, 30, 100, 500];
  const [depositAmount, setDepositAmount] = useState(10);
  const [isCustomAmount, setIsCustomAmount] = useState(false);
  const [depositMethods, setDepositMethods] = useState([]);
  const [depositMethod, setDepositMethod] = useState(null);
  const [bonusCampaigns, setBonusCampaigns] = useState([]);
  const [bonusCampaign, setBonusCampaign] = useState("no_bonus");
  const [depositFinalData, setDepositFinalData] = useState(null);
  const [infoUrl, setInfoUrl] = useState("");

  const isAuthenticated = props.isAuthenticated;
  const userDetails = props.userDetails;
  const userBalance = props.userBalance;

  const [depositForm, setDepositForm] = useState({});
  const [depositModalOpen, setDepositModalOpen] = useState(false);
  const [deleteBonusModalOpen, setDeleteBonusModalOpen] = useState(false);
  const [customDepositAmountOpen, setCustomDepositAmountOpen] = useState(false);
  const [depositFinalModalOpen, setDepositFinalModalOpen] = useState(false);
  const [readCarefullyModalOpen, setReadCarefullyModalOpen] = useState(false);

  const [creditCardInfo, setCreditCardInfo] = useState({
    NameOnCC: "",
    CardNumber: "",
    ExpMonth: "",
    ExpYear: "",
    CVV: "",
  });

  const [regErrors, setRegErrors] = useState({
    NameOnCC: "",
    CardNumber: "",
    ExpMonth: "",
    ExpYear: "",
    CVV: "",
  });

  const toggleDepositModal = () => {
    if (!depositModalOpen) {
      getDepositMethods();
    }
    setDepositModalOpen(!depositModalOpen);
  };
  const toggleDeleteBonusModalOpen = () => {
    setDeleteBonusModalOpen(!deleteBonusModalOpen);
  };
  const toggleReadCarefullyModal = () => {
    setReadCarefullyModalOpen(!readCarefullyModalOpen);
  };
  const toggleDepositFinalModalOpen = () => {
    setDepositFinalModalOpen(!depositFinalModalOpen);
  };

  useEffect(() => {
    getDepositMethods();
  }, [depositAmount]);

  const getDepositMethods = async () => {
    if (depositAmount) {
      props.setSpinner(true);
      var response = await api.post("/deposit/methods", {
        amount: depositAmount,
      });
      props.setSpinner(false);
      if (response.status === 200) {
        const filteredUsers = response.data.methods.filter(
          (method) => !method.method_id.includes("COINSPAID")
        );
        setDepositMethods(filteredUsers);

        if (
          !response.data.methods.filter(
            (method) => method.method_id === depositMethod
          ).length
        ) {
          setDepositMethod(null);
        }

        setBonusCampaigns(response.data.campaigns);
        if (
          !response.data.campaigns.filter(
            (campaign) => campaign.bonus_campaign.id === bonusCampaign
          ).length
        ) {
          setBonusCampaign("no_bonus");
        }
      }
    }
  };

  const [interacPaymentToken, setInteracPaymentToken] = useState();
  const [interacTransactionId, setInteracTransactionId] = useState();

  const submitDeposit = async (event) => {
    event.preventDefault();
    props.setSpinner(true);

    if (depositMethod == "BzPay:CC") {
      var valid = validateCCForm();
      if (!valid) {
        props.setSpinner(false);
        return;
      }
    }

    var postData = {
      amount: depositAmount,
      // amount: 1,
      method: depositMethod,
      campaign: bonusCampaign,
    };

    if (depositMethod == "BzPay:CC") {
      postData.creditCardInfo = creditCardInfo;
    }

    var response = await api.post("/deposit", postData);
    props.setSpinner(false);
    if (response.status === 200) {
      if (
        response.data.status === "APPROVED" &&
        response.data.fields_for === "BzPay:CC"
      ) {
        // setDepositFinalData(response.data.data);

        props.showAlert(__("Success"), __(response.data.message));

        setCreditCardInfo({
          NameOnCC: "",
          CardNumber: "",
          ExpMonth: "",
          ExpYear: "",
          CVV: "",
        });
        setDepositModalOpen(false);
      } else if (
        response.data.status === "additional_fields" &&
        response.data.fields_for === "webpayment"
      ) {
        setDepositModalOpen(false);
        setDepositFinalData(response.data.data);
        setDepositFinalModalOpen(true);
      } else if (
        response.data.status === "additional_fields" &&
        response.data.fields_for === "interac"
      ) {
        setInteracPaymentToken(response.data.data.payment_token);
        setInteracTransactionId(response.data.data.transactionId);
        setTimeout(() => {
          document.getElementById("interac_form").submit();
        }, 100);
      } else if (response.data.status === "redirect") {
        window.location.href = response.data.redirectUrl;
      } else {
        props.showAlert(null, __(response.data.message), true);
      }
    } else {
      props.showAlert(null, __(response.data.message), true);
    }
  };

  const doDeleteBonuses = async () => {
    props.setSpinner(true);
    var response = await api.post("/delete-bonus");
    if (response.status === 200) {
      props.setSpinner(false);
      toggleDeleteBonusModalOpen();
      props.getUserBalance();
      props.showAlert(null, __(response.data.message));
    } else {
      props.showAlert(null, __(response.data.message));
    }
  };

  //Mobile Device detection
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  useEffect(() => {
    setIsMobileDevice(isMobile());
    setDepositFinalData(null);
  }, []);

  const updateCCInput = (ev) => {
    var target = ev.target;
    var field = target.name;
    var value = target.value;

    setCreditCardInfo({ ...creditCardInfo, [field]: value });
  };

  const validateCCForm = () => {
    var valid = true;
    // return valid;
    var errorsTmp = {};
    // alert(44);

    if (
      creditCardInfo.NameOnCC.length < 2 ||
      creditCardInfo.NameOnCC.length > 250
    ) {
      errorsTmp = { ...errorsTmp, NameOnCC: __("Please enter the name") };
      valid = false;
    }

    if (
      creditCardInfo.CardNumber.length < 2 ||
      creditCardInfo.CardNumber.length > 250
    ) {
      errorsTmp = {
        ...errorsTmp,
        CardNumber: __("Please enter the card number"),
      };
      valid = false;
    }

    if (
      creditCardInfo.CardNumber.length < 2 ||
      creditCardInfo.CardNumber.length > 250
    ) {
      errorsTmp = {
        ...errorsTmp,
        CardNumber: __("Please enter the card number"),
      };
      valid = false;
    }

    if (creditCardInfo.ExpMonth.length < 1) {
      errorsTmp = {
        ...errorsTmp,
        ExpMonth: __("Please enter the expiry month"),
      };
      valid = false;
    }

    if (creditCardInfo.ExpYear.length < 1) {
      errorsTmp = {
        ...errorsTmp,
        ExpYear: __("Please enter the expiry year"),
      };
      valid = false;
    }

    if (creditCardInfo.CVV.length < 1) {
      errorsTmp = {
        ...errorsTmp,
        CVV: __("Please enter the CVV"),
      };
      valid = false;
    }

    setRegErrors(errorsTmp);
    return valid;
  };

  return (
    <>
      <form
        id="interac_form"
        action={`https://interac.express-connect.com/webflow?transaction=${interacTransactionId}`}
        method="post"
      >
        <input type="hidden" name="token" value={interacPaymentToken} />
      </form>

      <div className="deposit-methods legal_text_area legal_description">
        <h5 className="modal-title legal_heading padding_top_0">
          {__("Deposit")}
        </h5>

        <div className="deposit-method">
          <div className="alert d-none alert-danger"></div>
          <form
            method="post"
            id="internalDepositForm"
            className="depositform"
            action={""}
            onSubmit={submitDeposit}
          >
            <div className="modal_amount_area text-white">
              <strong>{__("Amount")}</strong>
              <div className="chimp-radio-field">
                {depositAmounts.map((val, index) => (
                  <div
                    className="cashier_amount_lavel"
                    key={index}
                    style={{ marginRight: 10 }}
                  >
                    <input
                      type="radio"
                      className={"deposit_campaign_check " + props.landingType}
                      id={"fiat_amount_selector" + val}
                      onChange={(ev) => {
                        setDepositAmount(val);
                        setCustomDepositAmountOpen(false);
                      }}
                      checked={depositAmount === val}
                      value={val}
                    />

                    <label
                      for={"fiat_amount_selector" + val}
                      className="radio_area"
                    >
                      <div className="radio_check_and_text_area">
                        <div className="radio_box">
                          <div className="radio_checked_box hello"></div>
                        </div>
                        <div className="radio_text">
                          <span className="currency">{val}</span>
                        </div>
                      </div>
                    </label>
                  </div>
                ))}
                <div className="cashier_amount_lavel">
                  <input
                    type="radio"
                    id="CustomDepositAmount"
                    className={"deposit_campaign_check " + props.landingType}
                    onChange={(ev) => {
                      setDepositAmount(depositAmount.toString());
                      setCustomDepositAmountOpen(ev.target.checked);
                    }}
                    checked={customDepositAmountOpen}
                  />
                  <label for={"CustomDepositAmount"} className="radio_area">
                    <div className="radio_check_and_text_area">
                      <div className="radio_box">
                        <div className="radio_checked_box"></div>
                      </div>
                      <div className="radio_text">
                        <span className="currency">{__("Custom Amount")}</span>
                      </div>
                    </div>
                  </label>
                </div>
              </div>
              <div></div>
            </div>
            <div className="modal_amount_area text-white">
              <div></div>
              {customDepositAmountOpen && (
                <div className="form_area">
                  <div className="input_item">
                    <input
                      type="number"
                      className="input_box  margin_bottom_30 border_bottom"
                      placeholder="Amount"
                      value={depositAmount.toString()}
                      onChange={(ev) =>
                        setDepositAmount(parseInt(ev.target.value).toString())
                      }
                    />
                    &nbsp;
                  </div>
                </div>
              )}
              <div></div>
            </div>
            <div className="text-white">
              <strong>{__("Payment Method")}</strong>
            </div>
            <div className="reg-field chimp-select-field payment_method_list">
              <div className="banking_area">
                <div className="banking_list_area">
                  {depositMethods.map((method, index) => (
                    <>
                      <div className={"single_banking e_wallet_method "}>
                        <input
                          id={"all_" + method.id}
                          onChange={() => {
                            setDepositMethod(method.method_id);
                            // alert(method.method_id);
                          }}
                          className={props.landingType}
                          type="radio"
                          checked={method.method_id === depositMethod}
                          value={method.method_id}
                        />
                        <label htmlFor={"all_" + method.id}>
                          <ul>
                            <li className="payment_logo_area">
                              <span className="helper"></span>
                              <span className="payment_text_mobile">
                                <span className="helper"></span>
                                <span className="method_logo_text">
                                  {__("Method Logo")}
                                </span>
                              </span>
                              <div
                                className="method_logo"
                                style={{
                                  backgroundImage: "url(" + method.logo + ")",
                                }}
                              ></div>
                              <div className="clearfix"></div>
                            </li>
                            <li className="payment_method_name">
                              <span className="helper"></span>
                              <span className="payment_text_mobile">
                                {__("Method Name")}
                              </span>
                              <span className="payment_content">
                                {" "}
                                {method.method}
                              </span>
                              <div className="clearfix"></div>
                            </li>
                            <li className="min_payment_amount">
                              <span className="payment_text_mobile">
                                {__("Limit Amount")}
                              </span>
                              <span className="payment_content">
                                {__("MIN")} {method.min_withdrawal}
                              </span>
                              <div className="clearfix"></div>
                            </li>
                          </ul>
                        </label>
                        <label
                          htmlFor={"all_" + method.id}
                          className="payment_check_mark"
                        >
                          <i className="fas fa-check selected_method_icon"></i>
                        </label>
                      </div>
                    </>
                  ))}
                </div>
              </div>
            </div>
            {depositMethod == "Interac" && (
              <div>
                ® {__("Trademark of Interac Corp. Used under license.")}
              </div>
            )}

            <div className="campaigns-wrap text-white">
              <label>
                <h3>{__("Bonus Campaigns")}</h3>
              </label>
              <div className="campaigns">
                {bonusCampaigns.length ? (
                  <>
                    {bonusCampaigns.map((campaign, index) => (
                      <div className="campaign">
                        <input
                          type="radio"
                          id={campaign.uniqid + "_id"}
                          value={campaign.bonus_campaign.id}
                          checked={bonusCampaign === campaign.bonus_campaign.id}
                          onChange={(ev) =>
                            setBonusCampaign(campaign.bonus_campaign.id)
                          }
                        />
                        <label
                          htmlFor={campaign.uniqid + "_id"}
                          className="check_box"
                        >
                          <i className="fas fa-check"></i>
                        </label>{" "}
                        <label
                          htmlFor={campaign.uniqid + "_id"}
                          className="campaign_label"
                        >
                          {campaign.bonus_campaign.title}
                          {campaign.bonus_campaign.campaign_information && (
                            <a
                              className="info_popover"
                              data-trigger="hover"
                              href="javascript:"
                              data-toggle="popover"
                              img={campaign.campaign_image}
                              content={
                                campaign.bonus_campaign.campaign_information
                              }
                            >
                              <i
                                className="fa fa-info-circle"
                                aria-hidden="true"
                              ></i>
                            </a>
                          )}
                        </label>
                        <div className="clearfix"></div>
                      </div>
                    ))}
                    <div className="campaign">
                      <input
                        id="no_bonus"
                        checked={bonusCampaign === "no_bonus"}
                        onChange={() => setBonusCampaign("no_bonus")}
                        type="radio"
                        value="no_bonus"
                      />
                      <label htmlFor="no_bonus" className="check_box">
                        <i className="fas fa-check"></i>
                      </label>{" "}
                      <label htmlFor="no_bonus" className="campaign_label">
                        {__("No Bonus")}
                      </label>
                    </div>
                  </>
                ) : (
                  <div className="campaign">
                    <input
                      id="no_bonus"
                      checked={true}
                      type="radio"
                      onChange={() => setBonusCampaign("no_bonus")}
                    />
                    <label htmlFor="no_bonus" className="check_box">
                      <i className="fas fa-check"></i>
                    </label>
                    {userDetails.acceptsBonus ? (
                      <>
                        <label htmlFor="no_bonus" className="campaign_label">
                          {__("No bonus available")}
                        </label>
                      </>
                    ) : (
                      <label htmlFor="no_bonus" className="campaign_label">
                        {__("You have chosen not to accept bonus")}
                      </label>
                    )}
                  </div>
                )}
              </div>
            </div>

            <div
              className={
                "credit_card_from_area " +
                (depositMethod == "BzPay:CC" ? "d-block" : "d-none")
              }
            >
              <div className="form_area">
                <div className="row">
                  <div className="col-md-6">
                    <div className="input_item">
                      <div className="name">
                        {__("Card Name")}
                        <span className="requried_icon">*</span>
                      </div>
                      <input
                        type="text"
                        name="NameOnCC"
                        className="input_box  border_bottom"
                        value={creditCardInfo.NameOnCC}
                        onChange={updateCCInput}
                      />
                      <div className="errorMsg">{regErrors.NameOnCC}</div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input_item">
                      <div className="name">
                        {__("Card Number")}
                        <span className="requried_icon">*</span>
                      </div>
                      <input
                        type="number"
                        name="CardNumber"
                        className="input_box  border_bottom"
                        value={creditCardInfo.CardNumber}
                        onChange={updateCCInput}
                      />
                      <div className="errorMsg">{regErrors.CardNumber}</div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="input_item">
                      <div className="name">
                        {__("Expiry Month")}
                        <span className="requried_icon">*</span>
                      </div>
                      <input
                        type="number"
                        name="ExpMonth"
                        step="1"
                        min="1"
                        max="12"
                        placeholder="EX: 01"
                        className="input_box  border_bottom"
                        value={creditCardInfo.ExpMonth}
                        onChange={updateCCInput}
                      />
                      <div className="errorMsg">{regErrors.ExpMonth}</div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="input_item">
                      <div className="name">
                        {__("Expiry Year")}
                        <span className="requried_icon">*</span>
                      </div>
                      <input
                        type="number"
                        name="ExpYear"
                        step="1"
                        min="1900"
                        placeholder="EX: 2022"
                        value={creditCardInfo.ExpYear}
                        onChange={updateCCInput}
                        className="input_box  border_bottom"
                      />
                      <div className="errorMsg">{regErrors.ExpYear}</div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="input_item">
                      <div className="name">
                        {__("CVV")}
                        <span className="requried_icon">*</span>
                      </div>
                      <input
                        type="number"
                        name="CVV"
                        className="input_box  border_bottom"
                        value={creditCardInfo.CVV}
                        onChange={updateCCInput}
                      />
                      <div className="errorMsg">{regErrors.CVV}</div>
                    </div>
                  </div>
                  <div className="clearfix"></div>
                </div>
              </div>
            </div>
            <div className="reg-submit">
              <button
                type="submit"
                className={"angle_btn small margin_0_auto " + props.landingType}
              >
                {__("Continue")}
              </button>
            </div>
            <div className="form_error ubonus_campaign"></div>
          </form>
        </div>
      </div>

      <Modal
        className="cashierModal"
        size="lg"
        show={depositFinalModalOpen}
        onHide={toggleDepositFinalModalOpen}
        centered
      >
        <Modal.Header className="modal-header">
          <h5 className="modal-title">{__("Complete Deposit")}</h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={toggleDepositFinalModalOpen}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </Modal.Header>
        <Modal.Body className="">
          {!!depositFinalData && !!depositFinalData.invoice_url && (
            <iframe
              style={{ width: "100%", minHeight: "350px" }}
              src={depositFinalData.invoice_url}
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}
